<template>
  <div class="container-fluid">
    <SettingTab
        :items="items"
        :columns="columns"
        :isCalled="false"
        :selectedValue="selectedItem"
        @editItem="showEditDialog"
        v-model="selectedItem"
        :captionSpr="captionSett"
        :captionTab="captiontable"
        :urls="urls"
        ref="SportTab"
    >
    </SettingTab>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование настройки" size="lg" hide-footer
             id="editModal">
      <div class="row">
        <b-col sm="6" class="d-block">
          <label for="minvalue" class="mb-1">Значение От</label>
          <b-form-invalid-feedback :state="validValue.minval">Указано пустое значение От</b-form-invalid-feedback>
          <b-form-input id="minvalue" type="number" v-model="selectedItem.minValue" min="0" max="365" step="1" @change="onChangeMin()"/>
        </b-col>
        <b-col sm="6" class="d-block">
          <label for="maxvalue" class="mb-1">Значение До</label>
          <b-form-invalid-feedback :state="validValue.maxval">Указано пустое значение До</b-form-invalid-feedback>
          <b-form-input id="maxvalue" type="number" v-model="selectedItem.maxValue" min="0" max="365" step="1" @change="onChangeMax()"/>
        </b-col>
      </div>
      <div class="row">
        <b-col sm="6" class="d-block">
          <label class="mb-1">Значение Цвета Фона</label>
          <b-form-invalid-feedback :state="validValue.colvalBack">Не указан цвет Фона</b-form-invalid-feedback>
          <b-form-input type="color" v-model="selectedItem.colorBackground"/>
        </b-col>
        <b-col sm="6" class="d-block">
          <label class="mb-1">Значение Цвета Текста</label>
          <b-form-invalid-feedback :state="validValue.colvalFont">Не указан цвет Текста</b-form-invalid-feedback>
          <b-form-input type="color" v-model="selectedItem.colorFont"/>
        </b-col>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="save()">Сохранить</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="modalEditOpened=!modalEditOpened">Отменить
      </b-button>

    </b-modal>
  </div>
</template>

<script>
import SettingTab from '@/components/TabSpr.vue'
import http from '@/http-common'

export default {
  name: 'SettingEkp',
  components: {SettingTab},
  data() {
    return {
      items: [],
      editItem: {},
      urls: {
        save: '/setting/ekp',
        delete: '/setting/ekp',
      },
      captionSett: {
        name: 'Цвет ЕКП',
        nameR: 'цвета ЕКП'
      },
      columns: [
        {key: 'minValue', label: 'Значение От'},
        {key: 'maxValue', label: 'Значение До'},
        {key: 'colorStyle', label: 'Значение Цвета'},
        {key: 'edit_field', label: ''}
      ],
      selectedItem: {id: 0, minValue: 0, maxValue: 0, colorFont: "#000000", colorBackground: "#ffffff"},
      modalEditOpened: false,
      validValue: {
        minval: true,
        maxval: true,
        colval: true,
        form: true,
      },
      captiontable:'Настройка таблицы ЕКП'
    }
  },
  created() {
    this.loadSetting();
  },
  methods: {
    loadSetting() {
      var vm = this;
      http.get('/setting/ekp')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.minValue || this.selectedItem.minValue == '') {
        this.validValue.minval = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.maxValue || this.selectedItem.maxValue == '') {
        this.validValue.maxval = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.colorBackground || this.selectedItem.colorBackground == '') {
        this.validValue.colval = false;
        this.validValue.form = false;
      }
    },
    showEditDialog() {
      this.modalEditOpened = !this.modalEditOpened;
    },
    save() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.$refs.SportTab.save(this.selectedItem);
      }
    },
    onChangeMin() {
      if (this.selectedItem.minValue > this.selectedItem.maxValue) {
        this.selectedItem.maxValue = this.selectedItem.minValue
      }
    },
    onChangeMax() {
      if (this.selectedItem.minValue > this.selectedItem.maxValue) {
        this.selectedItem.minValue = this.selectedItem.maxValue
      }
    },
  }
}
</script>
